/* SHOPAAREL LUX — lightweight interactions (no dependencies) */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var inr = function (cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); };
  /* Shiprocket Smart Cart (app embed) intercepts product-form "add" clicks itself and opens its own drawer */
  var smartCart = function () { return !!window.shiprocketSmartCart; };

  /* ---------- content is always visible (no scroll-reveal) ---------- */
  function initReveal(root) { $$('.sp-reveal', root).forEach(function (e) { e.classList.add('is-in'); }); }

  /* ---------- festive: tiny gold sparkle burst on tap ---------- */
  function burst(el) {
    if (RM || !el) return;
    for (var k = 0; k < 10; k++) {
      var s = document.createElement('i'); s.className = 'sp-burst';
      var a = k / 10 * 6.283 + Math.random() * 0.4, d = 22 + Math.random() * 14;
      s.style.setProperty('--dx', (Math.cos(a) * d).toFixed(1) + 'px'); s.style.setProperty('--dy', (Math.sin(a) * d).toFixed(1) + 'px');
      el.appendChild(s);
      setTimeout(function (x) { return function () { x.remove(); }; }(s), 800);
    }
  }

  /* ---------- true shade colour (same method as the combo pages):
     every Shopaarel shade image carries a solid colour strip on its right edge ---------- */
  var hexCache = {}; try { hexCache = JSON.parse(localStorage.getItem('sp-shade-hex') || '{}'); } catch (e) {}
  function shadeColor(url, cb) {
    if (!url) return;
    var key = url.split('?')[0].split('/').pop(); if (hexCache[key]) return cb(hexCache[key]);
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight;
        var x = c.getContext('2d'); x.drawImage(im, 0, 0);
        var d = x.getImageData(Math.floor(c.width * 0.96), Math.floor(c.height * 0.08), 1, 1).data;
        if (d[3] < 200 || (d[0] > 238 && d[1] > 238 && d[2] > 238)) return; /* no colour strip on this image */
        var hex = '#' + [d[0], d[1], d[2]].map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join('');
        hexCache[key] = hex; try { localStorage.setItem('sp-shade-hex', JSON.stringify(hexCache)); } catch (e) {}
        cb(hex);
      } catch (e) {}
    };
    im.src = url;
  }

  /* ---------- toast + ajax add ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sp-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span>' + msg + '</span><a href="/cart">View bag</a>';
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  }
  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
      .then(function (res) {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          $$('[data-cart-count], .header__cart-count, [data-js-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
        }).catch(function () {});
        return res;
      });
  }
  function bindQuickAdd(root) {
    $$('[data-sp-add]', root).forEach(function (btn) {
      if (btn._b) return; btn._b = 1;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-sp-add');
        var label = btn.innerHTML;
        btn.disabled = true; btn.textContent = 'Adding…';
        addToCart([{ id: +id, quantity: 1 }]).then(function () {
          btn.disabled = false; btn.classList.add('is-added'); btn.textContent = 'Added ✓';
          toast('Added to your bag');
          setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; }, 2200);
        }).catch(function (err) {
          btn.disabled = false; btn.innerHTML = label;
          toast((err && err.description) || 'Could not add — please try again');
        });
      });
    });
  }

  /* ---------- generic rails (arrows) + "see all" ---------- */
  function initRails(root) {
    $$('[data-sp-rail]', root).forEach(function (wrap) {
      var rail = $('.sp-rail, .sp-looks', wrap); if (!rail) return;
      $$('[data-sp-prev],[data-sp-next]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = b.hasAttribute('data-sp-next') ? 1 : -1;
          rail.scrollBy({ left: dir * rail.clientWidth * 0.85, behavior: RM ? 'auto' : 'smooth' });
        });
      });
    });
    $$('[data-sp-more]', root).forEach(function (b) {
      b.addEventListener('click', function () { var g = document.getElementById(b.getAttribute('data-sp-more')); if (g) g.classList.add('is-all'); });
    });
  }

  /* ---------- hero slideshow ---------- */
  function initHero(root) {
    $$('[data-sp-hero]', root).forEach(function (hero) {
      var track = $('.sp-hero__track', hero), slides = $$('.sp-hero__slide', hero), dots = $$('.sp-hero__dot', hero);
      if (slides.length < 2) { slides[0] && slides[0].classList.add('is-active'); return; }
      var i = 0, timer, interval = +(hero.getAttribute('data-interval') || 5500), visible = true, hovering = false;
      hero.style.setProperty('--sp-int', interval + 'ms');
      function mark(n) {
        i = n;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
        dots.forEach(function (d, k) { d.classList.remove('is-active'); if (k === n) { void d.offsetWidth; d.classList.add('is-active'); } });
      }
      function go(n) { n = (n + slides.length) % slides.length; track.scrollTo({ left: n * track.clientWidth, behavior: RM ? 'auto' : 'smooth' }); mark(n); }
      function play() { clearInterval(timer); if (RM) return; timer = setInterval(function () { if (visible && !hovering && !document.hidden) go(i + 1); }, interval); }
      var st;
      track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var n = Math.round(track.scrollLeft / track.clientWidth); if (n !== i) { mark(n); play(); } }, 90); }, { passive: true });
      track.addEventListener('touchstart', function () { hovering = true; }, { passive: true });
      track.addEventListener('touchend', function () { hovering = false; play(); }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
      var p = $('[data-sp-hprev]', hero), nx = $('[data-sp-hnext]', hero);
      p && p.addEventListener('click', function () { go(i - 1); play(); });
      nx && nx.addEventListener('click', function () { go(i + 1); play(); });
      hero.addEventListener('mouseenter', function () { hovering = true; });
      hero.addEventListener('mouseleave', function () { hovering = false; });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(hero);
      mark(0); play();
    });
  }

  /* ---------- festive sparkles (tiny canvas, pauses offscreen) ---------- */
  function initSparkles(root) {
    if (RM) return;
    $$('[data-sp-sparkles]', root).forEach(function (host) {
      var c = document.createElement('canvas'); c.className = 'sp-sparkles'; host.appendChild(c);
      var ctx = c.getContext('2d'), W, H, dpr = Math.min(window.devicePixelRatio || 1, 2), P = [], run = false, raf;
      var N = +(host.getAttribute('data-sp-sparkles') || 16);
      if (window.innerWidth < 700) { N = Math.ceil(N * 0.6); dpr = Math.min(dpr, 1.5); }
      function size() { W = host.clientWidth; H = host.clientHeight; c.width = W * dpr; c.height = H * dpr; c.style.width = W + 'px'; c.style.height = H + 'px'; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
      function spawn(p) { p.x = Math.random() * W; p.y = H + Math.random() * H * 0.4; p.r = 0.8 + Math.random() * 2.2; p.v = 0.15 + Math.random() * 0.45; p.a = 0; p.t = Math.random() * 6.28; p.max = 0.35 + Math.random() * 0.5; return p; }
      size(); for (var k = 0; k < N; k++) { var q = spawn({}); q.y = Math.random() * H; P.push(q); }
      function tick() {
        ctx.clearRect(0, 0, W, H);
        P.forEach(function (p) {
          p.y -= p.v; p.t += 0.03; p.x += Math.sin(p.t) * 0.25; p.a = Math.min(p.max, p.a + 0.01);
          if (p.y < -10) spawn(p);
          var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
          g.addColorStop(0, 'rgba(255,236,190,' + p.a + ')'); g.addColorStop(1, 'rgba(232,180,90,0)');
          ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 4, 0, 6.283); ctx.fill();
        });
        raf = requestAnimationFrame(tick);
      }
      window.addEventListener('resize', size, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) {
        if (e[0].isIntersecting && !run) { run = true; tick(); } else if (!e[0].isIntersecting && run) { run = false; cancelAnimationFrame(raf); }
      }).observe(host);
    });
  }

  /* ---------- spotlight shade picking (home) ---------- */
  function initSpotlight(root) {
    $$('[data-sp-spot]', root).forEach(function (s) {
      var img = $('[data-sp-spot-img]', s), price = $('[data-sp-spot-shade]', s), link = $('[data-sp-spot-link]', s);
      $$('.sp-spot__shade', s).forEach(function (b) {
        function pick(e) {
          $$('.sp-spot__shade', s).forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          if (e && e.type === 'click') burst(b);
          var src = b.getAttribute('data-img'); if (src && img) { img.style.opacity = 0; var n = new Image(); n.onload = function () { img.src = src; img.style.opacity = 1; }; n.src = src; }
          if (price) price.textContent = b.getAttribute('data-name');
          if (link) link.href = b.getAttribute('data-url');
        }
        b.addEventListener('mouseenter', pick); b.addEventListener('click', pick);
      });
    });
  }

  /* ---------- PRODUCT PAGE ---------- */
  function initPDP(root) {
    var pdp = $('[data-sp-pdp]', root); if (!pdp || pdp._i) return; pdp._i = 1;
    var data = JSON.parse($('[data-sp-product-json]', pdp).textContent);
    var form = $('form[action*="/cart/add"]', pdp);
    var select = $('select[name="id"]', form);
    var current = data.variants.filter(function (v) { return v.id == select.value; })[0] || data.variants[0];
    var lowAt = +(pdp.getAttribute('data-low') || 0);
    var inv = JSON.parse(($('[data-sp-inv]', pdp) || { textContent: '{}' }).textContent || '{}');

    /* gallery */
    var track = $('.sp-gal__track', pdp), count = $('.sp-gal__count', pdp), dotsWrap = $('.sp-gal__dots', pdp), thumbs = $('.sp-gal__thumbs', pdp);
    function slides() { return $$('.sp-gal__slide', track); }
    function paintNav() {
      var n = slides().length, idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (count) count.textContent = (idx + 1) + ' / ' + n;
      if (dotsWrap) { dotsWrap.innerHTML = ''; for (var k = 0; k < n; k++) { var d = document.createElement('span'); if (k === idx) d.className = 'is-active'; dotsWrap.appendChild(d); } }
      if (thumbs) $$('.sp-gal__thumb', thumbs).forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
    }
    function buildThumbs() {
      if (!thumbs) return; thumbs.innerHTML = '';
      slides().forEach(function (s, k) {
        var im = $('img', s); var b = document.createElement('button'); b.type = 'button'; b.className = 'sp-gal__thumb'; b.setAttribute('aria-label', 'View image ' + (k + 1));
        if (im) { var t = document.createElement('img'); t.src = im.getAttribute('data-thumb') || im.currentSrc || im.src; t.alt = ''; t.loading = 'lazy'; b.appendChild(t); }
        b.addEventListener('click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: RM ? 'auto' : 'smooth' }); });
        thumbs.appendChild(b);
      });
    }
    var gs; track && track.addEventListener('scroll', function () { clearTimeout(gs); gs = setTimeout(paintNav, 60); }, { passive: true });
    function swapGallery(v) {
      var tpl = $('template[data-sp-group="' + v.id + '"]', pdp);
      if (!tpl) return;
      track.innerHTML = tpl.innerHTML; track.scrollLeft = 0; buildThumbs(); paintNav();
    }
    buildThumbs(); paintNav();

    /* option logic */
    var opts = data.options.length;
    function selectedOptions() { return $$('[data-sp-opt]', pdp).map(function (g) { var a = $('.is-active', g); return a ? a.getAttribute('data-value') : null; }); }
    function findVariant(sel) { return data.variants.filter(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); })[0]; }
    function update(v, fromUser) {
      if (!v) return; current = v;
      if (fromUser) { var stk = $('[data-sp-sticky]', pdp); if (stk) stk.removeAttribute('data-needs-pick'); }
      select.value = v.id; select.dispatchEvent(new Event('change', { bubbles: true }));
      $$('[data-sp-price]', pdp).forEach(function (e) { e.textContent = inr(v.price); });
      $$('[data-sp-compare]', pdp).forEach(function (e) { e.textContent = v.compare_at_price > v.price ? inr(v.compare_at_price) : ''; });
      $$('[data-sp-save]', pdp).forEach(function (e) {
        var s = v.compare_at_price > v.price ? v.compare_at_price - v.price : 0;
        e.parentElement.style.display = s ? '' : 'none';
        e.textContent = 'You save ' + inr(s) + ' (' + Math.round(s * 100 / v.compare_at_price) + '%)';
      });
      $$('[data-sp-chosen]', pdp).forEach(function (e) { e.textContent = v.title; });
      var st = $('[data-sp-stock]', pdp);
      if (st) {
        var q = inv[v.id];
        st.classList.remove('is-low', 'is-out');
        if (!v.available) { st.classList.add('is-out'); $('span', st).textContent = 'This shade is sold out — pick a neighbour shade'; }
        else if (lowAt && typeof q === 'number' && q > 0 && q <= lowAt) { st.classList.add('is-low'); $('span', st).textContent = 'Selling fast — only a few left in shade ' + v.title; }
        else $('span', st).textContent = 'In stock · ready to ship';
      }
      var add = $('[data-sp-addbtn]', pdp);
      if (add) { add.disabled = !v.available; $('span', add).textContent = v.available ? 'Add to bag' : 'Sold out'; }
      $$('.shiprocket-headless', pdp).forEach(function (h) { h.style.opacity = v.available ? '' : '.45'; h.style.pointerEvents = v.available ? '' : 'none'; });
      $$('[data-sp-sticky-img]', pdp).forEach(function (im) { var g = $('template[data-sp-group="' + v.id + '"]', pdp); if (g) { var f = g.content.querySelector('img'); if (f) im.src = f.getAttribute('data-thumb') || f.src; } });
      if (fromUser) {
        swapGallery(v);
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      }
    }
    $$('[data-sp-opt]', pdp).forEach(function (group, gi) {
      $$('[data-value]', group).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-value]', group).forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
          burst($('.sp-shade__dot', b) || $('.sp-vbtn__dot', b));
          var v = findVariant(selectedOptions());
          if (!v && opts === 1) v = data.variants.filter(function (x) { return x.options[0] === b.getAttribute('data-value'); })[0];
          update(v, true);
        });
      });
    });
    function pickShade(name) { var b = $('[data-sp-opt] [data-value="' + name + '"]', pdp); if (b) b.click(); }

    /* real shade swatches on text shade buttons.
       1st choice: the store's Globo Color Swatch library (same swatch images/colours as the previous site).
       Fallback: the colour strip on each variant image (same method as the combo pages). */
    function putDot(b, css, soldOut) {
      if ($('.sp-vbtn__dot', b)) return;
      var d = document.createElement('i'); d.className = 'sp-vbtn__dot'; d.setAttribute('aria-hidden', 'true');
      d.style.cssText = 'position:relative;display:inline-block;flex:0 0 auto;width:20px;height:20px;border-radius:50%;margin-right:8px;vertical-align:-5px;background-size:cover;background-position:center;' + css + ';box-shadow:inset 0 -3px 5px rgba(0,0,0,.14),0 0 0 1px rgba(0,0,0,.08)';
      if (soldOut) d.style.opacity = '.4';
      b.insertBefore(d, b.firstChild);
    }
    function globoItems(optName) {
      var all = window.globo_sw_options; if (!Array.isArray(all)) return null;
      var n = String(optName || '').trim().toLowerCase();
      var set = all.filter(function (o) { return String(o.name || '').trim().toLowerCase() === n; })[0];
      return set && set.option_items && set.option_items.length ? set.option_items : null;
    }
    function globoCss(it) {
      var c = it.custom || {}, url = '';
      if (+it.select_type === 3) {
        if (c.enable_upload_file !== false && c.upload_file && c.upload_file.server_url) url = c.upload_file.server_url;
        else if (c.image_url && c.image_url.server_url) url = c.image_url.server_url;
        if (url) return 'background-image:url("' + String(url).replace(/"/g, '') + '");background-color:' + (c.color_1 && c.color_1 !== 'transparent' ? c.color_1 : '#f3e9ec');
      }
      if (c.enable_two_color && c.color_2 && c.color_2 !== 'transparent') return 'background:linear-gradient(135deg,' + c.color_1 + ' 50%,' + c.color_2 + ' 50%)';
      if (c.color_1 && c.color_1 !== 'transparent') return 'background-color:' + c.color_1;
      return '';
    }
    (function shadeDots() {
      $$('[data-sp-opt]', pdp).forEach(function (group) {
        var k = +group.getAttribute('data-sp-opt'), btns = $$('.sp-vbtn', group); if (!btns.length) return;
        var items = globoItems(data.options[k]);
        var left = btns.filter(function (b) {
          if (!items) return true;
          var val = String(b.getAttribute('data-value')).trim().toLowerCase();
          var it = items.filter(function (x) { return String(x.value).trim().toLowerCase() === val; })[0];
          var css = it && globoCss(it); if (!css) return true;
          var v = data.variants.filter(function (x) { return x.options[k] === b.getAttribute('data-value'); })[0];
          putDot(b, css, v && !data.variants.some(function (x) { return x.options[k] === b.getAttribute('data-value') && x.available; }));
          return false;
        });
        /* fallback only for single-option products whose variants each have their own image */
        if (!left.length || opts !== 1 || data.variants.length < 3) return;
        var srcs = data.variants.map(function (v) { return v.featured_image && v.featured_image.src; });
        if (srcs.some(function (x) { return !x; }) || srcs.filter(function (x, i) { return srcs.indexOf(x) === i; }).length !== srcs.length) return;
        left.forEach(function (b) {
          var v = data.variants.filter(function (x) { return x.options[0] === b.getAttribute('data-value'); })[0]; if (!v) return;
          var src = v.featured_image.src; if (src.indexOf('//') === 0) src = 'https:' + src;
          src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
          shadeColor(src, function (hex) { putDot(b, 'background-color:' + hex, !v.available); });
        });
      });
    })();

    /* tone tabs */
    $$('.sp-tone', pdp).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.sp-tone', pdp).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var tone = t.getAttribute('data-tone');
        $$('.sp-shade', pdp).forEach(function (s) { s.classList.toggle('is-dim', tone !== 'all' && s.getAttribute('data-tone') !== tone); });
      });
    });

    /* shade finder */
    var finder = $('[data-sp-finder]', pdp);
    if (finder) {
      var open = $('[data-sp-finder-open]', pdp), step = 0, tone;
      var map = JSON.parse(finder.getAttribute('data-map'));
      open && open.addEventListener('click', function () { finder.classList.toggle('is-open'); step = 0; render(); });
      function render() {
        var q = $('.sp-finder__q', finder), o = $('.sp-finder__opts', finder), r = $('.sp-finder__res', finder);
        r.innerHTML = ''; o.innerHTML = '';
        if (step === 0) {
          q.textContent = 'Step 1 of 2 — Which is closest to your skin?';
          [['fair', 'Fair', '#f4dcc4'], ['light', 'Light', '#ecc9a4'], ['wheatish', 'Wheatish', '#d6a77a'], ['dusky', 'Dusky', '#b07c52'], ['deep', 'Deep', '#7a4a2c']].forEach(function (x) {
            var b = document.createElement('button'); b.type = 'button'; b.className = 'sp-finder__opt'; b.innerHTML = '<i style="background:' + x[2] + '"></i>' + x[1];
            b.onclick = function () { tone = x[0]; step = 1; render(); }; o.appendChild(b);
          });
        } else {
          q.textContent = 'Step 2 of 2 — Look at the veins on your wrist. They look…';
          [['cool', 'Blue / purple'], ['neutral', 'A mix of both'], ['warm', 'Green / olive']].forEach(function (x) {
            var b = document.createElement('button'); b.type = 'button'; b.className = 'sp-finder__opt'; b.style.paddingLeft = '14px'; b.textContent = x[1];
            b.onclick = function () {
              var shade = map[tone][x[0]]; pickShade(shade);
              o.innerHTML = '';
              q.textContent = 'Your Miracle match';
              r.innerHTML = 'We recommend <b>Shade ' + shade + '</b> — selected for you. Between two shades? Most pros mix them for a custom blend.';
            }; o.appendChild(b);
          });
        }
      }
    }

    /* quantity — the page's own stepper is the single source of truth */
    var qty = $('input[name="quantity"]', form), userQty = 1;
    $$('[data-sp-qty]', pdp).forEach(function (b) {
      b.addEventListener('click', function () { userQty = Math.max(1, userQty + (+b.getAttribute('data-sp-qty'))); qty.value = userQty; });
    });
    qty && qty.addEventListener('input', function () { if (+qty.value >= 1) userQty = +qty.value; });
    /* Kaching Bundles' widget lives in a hidden quick-view panel on this design, yet it pre-selects its
       "buy 2" deal and writes quantity=2 + a bundle property into THIS form. Shoppers can't see it, so we
       strip it and restore the shopper's quantity before Add to bag / Buy Now read the form. */
    function cleanForm() {
      if (!$('kaching-bundle', pdp)) $$('input[name="properties[__kaching_bundles]"]', form).forEach(function (i) { i.remove(); });
      if (qty && +qty.value !== userQty) qty.value = userQty;
    }
    pdp.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.shiprocket-headless, [data-sp-addbtn], .sp-buynow')) cleanForm(); }, true);
    [800, 2500, 5000].forEach(function (t) { setTimeout(cleanForm, t); });

    /* add to bag. When Shiprocket Smart Cart is installed it adds the item from this same click and opens its
       drawer — so we must NOT add again (that caused a double add). Safety net: if Smart Cart didn't add it, we do. */
    var addBtn = $('[data-sp-addbtn]', pdp);
    addBtn && addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      cleanForm();
      var sp = $('span', addBtn), lbl = sp.textContent, v = current, q = userQty;
      function done() { sp.textContent = 'Added ✓'; setTimeout(function () { sp.textContent = lbl; addBtn.disabled = false; }, 1800); }
      function fail(err) { sp.textContent = lbl; addBtn.disabled = false; toast((err && err.description) || 'Could not add — please try again'); }
      addBtn.disabled = true; sp.textContent = 'Adding…';
      if (smartCart()) {
        setTimeout(function () {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            var inCart = c.items.some(function (i) { return i.variant_id == v.id; });
            if (inCart) return done();
            addToCart([{ id: v.id, quantity: q }]).then(function () { done(); toast('Shade ' + v.title + ' added to your bag'); }).catch(fail);
          }).catch(function () { done(); });
        }, 2200);
        return;
      }
      addToCart([{ id: v.id, quantity: q }]).then(function () { done(); toast('Shade ' + v.title + ' added to your bag'); }).catch(fail);
    });

    /* Shiprocket fallback: if the 3-sec checkout button never renders, show a native Buy Now */
    var bn = $('.sp-buynow', pdp);
    if (bn) setTimeout(function () {
      if (!$('.sr-headless-checkout', bn)) {
        bn.classList.add('is-fallback');
        var fb = $('.sp-buynow__fallback', bn);
        fb && fb.addEventListener('click', function (e) {
          e.preventDefault();
          addToCart([{ id: current.id, quantity: userQty }]).then(function () { location.href = '/checkout'; });
        });
      }
    }, 5000);

    /* sticky bar */
    var sticky = $('[data-sp-sticky]', pdp), anchor = $('[data-sp-sticky-anchor]', pdp);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      /* desktop: show once the price box scrolls away. mobile: show whenever the main Buy Now is off-screen
         (incl. on landing, so the price + CTA are in thumb reach from the very first second) */
      var mq = window.matchMedia('(max-width: 899px)'), buyBox = $('.sp-buy', pdp), anchorPast = false, buyVisible = false;
      function setSticky() {
        var on = mq.matches ? !buyVisible : anchorPast;
        sticky.classList.toggle('is-on', on); document.body.classList.toggle('sp-has-sticky', on);
      }
      new IntersectionObserver(function (e) { anchorPast = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; setSticky(); }).observe(anchor);
      if (buyBox) new IntersectionObserver(function (e) { buyVisible = e[0].isIntersecting; setSticky(); }, { rootMargin: '0px 0px -80px 0px' }).observe(buyBox);
      if (mq.addEventListener) mq.addEventListener('change', setSticky);
      var pick = $('[data-sp-pick]', sticky);
      if (pick) pick.addEventListener('click', function () {
        var o = $('.sp-opt', pdp); if (!o) return;
        o.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
        o.classList.remove('is-flash'); void o.offsetWidth; o.classList.add('is-flash');
      });
    }

    /* fbt add */
    bindQuickAdd(pdp);
    update(current, false);
  }

  /* ---------- collection filter drawer ---------- */
  function initDrawer(root) {
    $$('[data-sp-drawer-open]', root).forEach(function (b) {
      var d = document.getElementById(b.getAttribute('data-sp-drawer-open')); if (!d) return;
      b.addEventListener('click', function () { d.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; });
      $$('[data-sp-drawer-close]', d).forEach(function (c) { c.addEventListener('click', function () { d.classList.remove('is-open'); document.documentElement.style.overflow = ''; }); });
    });
    $$('[data-sp-sort]', root).forEach(function (s) {
      s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); });
    });
  }

  /* ---------- thumb zone: on phones, park the chat bubble bottom-LEFT (away from right-thumb scrolling) ---------- */
  function initChatPosition() {
    var mq = window.matchMedia('(max-width: 899px)'), tries = 0;
    function fix() {
      var f = document.getElementById('verifast-react-chatbot-iframe'); if (!f) return false;
      f.classList.toggle('sp-chat-left', mq.matches && f.offsetWidth > 0 && f.offsetWidth < 160);
      return true;
    }
    var iv = setInterval(function () {
      if (fix() || ++tries > 20) {
        clearInterval(iv);
        var f = document.getElementById('verifast-react-chatbot-iframe');
        if (f && 'MutationObserver' in window) new MutationObserver(fix).observe(f, { attributes: true, attributeFilter: ['style', 'width', 'height'] });
      }
    }, 1000);
    window.addEventListener('resize', fix, { passive: true });
  }

  function init(root) {
    root = root || document;
    initReveal(root); initHero(root); initSparkles(root); initRails(root); initSpotlight(root); bindQuickAdd(root); initPDP(root); initDrawer(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initChatPosition(); }); else { init(); initChatPosition(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
